import {Injectable} from "@angular/core";
import {ExportChartImage} from "./export-chart-image";
import {Chart} from "chart.js";

@Injectable({
  providedIn: 'root'
})

/*
01/09/2025 - Kauan
essa chart ficou feio pra processar, o chart js nao deixa copiar e jogar os dados do dataset pra outras posicoes (no caso o comparativo entrega
dois, o do ano anterior e o do ano posterior, mas os dados deles nao podem ser copiados e atribuidos pra outros datasets

(pra cada novo label do grafico (X/20XX) é criado um dataset novo já que o chart js tb nao aceita labels "vazios" (sem datasets))

o fluxo basicamente renomeia os dois primeiros datasets, cria os outros datasets vazios baseado nos tooltips, e depois troca eles de posicao
ou remove caso um dos datasets seja ocultado(ler changeChartLegendPosition)
*/

export class ProcessComparativoChart {
  animation: string;
  barPaddingTop: string;
  datasets: any[];
  legendPosition: string;
  firstDatasetYear: number;
  secDatasetYear: number;

  constructor (private exportChartImage: ExportChartImage) {}

  process(chart: any, name: string){
    this.saveCurrentDataChart(chart);
    chart.options.legend.position = 'right';
    chart.options.layout.padding.top = 30;
    chart.options.animation.duration = 1;
    chart.options.legend.labels.boxWidth = 10;
    //chart.legend.columnWidths[0] = 100;
    //chart.legend.columnWidths[1] = 100;

    let firstDatasetColor = chart.data.datasets[0].backgroundColor;
    let secDatasetColor = chart.data.datasets[1].backgroundColor;
    let changedFirst = false;
    let changedSec = false;

    const format = (n : number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format(n);

    let offsetSecondComparativeGroup : number = 0;
    let hiddenInfo: any [] = [];
    hiddenInfo.push(chart.isDatasetVisible(0));
    hiddenInfo.push(chart.isDatasetVisible(1));

    let yearControl = 0;

    chart.options.animation.onComplete = () => {
      const ctx = chart.ctx;
      ctx.font = Chart.helpers.fontString(
        13,
        Chart.defaults.global.defaultFontStyle,
        Chart.defaults.global.defaultFontFamily
      );
      ctx.textAlign = 'center';
      ctx.fillStyle = '#111111';
      ctx.textBaseline = 'bottom';
      if (name === 'myChart0'){
        ctx.fillText("Receitas por mês", 60 ,15);

      }
      else {
        ctx.fillText("Despesas por mês", 60 ,15);
      }

      ctx.font = Chart.helpers.fontString(
        11,
        Chart.defaults.global.defaultFontStyle,
        Chart.defaults.global.defaultFontFamily
      );

      ctx.textAlign = 'left';

      chart.legend.legendItems.forEach((item, index) => {
        const hitBox = chart.legend.legendHitBoxes[index];
        ctx.fillStyle = 'white';
        ctx.fillRect(hitBox.left + 62, hitBox.top, hitBox.width - 55 , hitBox.height);
        ctx.fillStyle = 'black';
        ctx.fillText(item.text.slice(9),hitBox.left + 65 ,(hitBox.top + hitBox.height / 2) + 6);
      });
    }

    chart.data.datasets.forEach((dataset) => {
      for (let i = 0; i < dataset.data.length; i++) {
        dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
        //obj = os novos labels 1/2025, 2/2025, etc
        let obj = null;
        //se estamos no primeiro mes valido (que nao tem valor 0, troque o label 20XX por mes/20XX)
        if (!changedFirst && dataset.data[i] !== 0 && yearControl === 0){
          changedFirst = true;
          if (i+1<10){
            chart.data.datasets[0].label = `0${i+1}/${this.firstDatasetYear}: ${format(dataset.data[i])}`;
          }
          else{
            chart.data.datasets[0].label = `${i+1}/${this.firstDatasetYear}: ${format(dataset.data[i])}`;
          }
        }
        //do contrario, crie um novo label mes/20XX
        else if (yearControl === 0 ){
          //minuciosidade, só pro 1/2024 ficar 01/2024
          if (i+1<10){
            obj = {
              label: `0${i+1}/${this.firstDatasetYear}: ${format(dataset.data[i])}`,
              backgroundColor: firstDatasetColor,
              boxWidth: 10
            }
          }
          else{
            obj = {
              label: `${i+1}/${this.firstDatasetYear}: ${format(dataset.data[i])}`,
              backgroundColor: firstDatasetColor,
              boxWidth: 10
            }
          }
        }
        //mesma coisa pro segundo ano
        if (!changedSec && dataset.data[i] !== 0 && yearControl === 1){
          changedSec = true;
          if (i+1<10){
            chart.data.datasets[1].label = `0${i+1}/${this.secDatasetYear}: ${format(dataset.data[i])}`;

          }
          else{
            chart.data.datasets[1].label = `${i+1}/${this.secDatasetYear}: ${format(dataset.data[i])}`;
          }
        }
        else if (yearControl === 1){
          if (i+1<10){
            obj = {
              label: `0${i+1}/${this.secDatasetYear}: ${format(dataset.data[i])}`,
              backgroundColor: secDatasetColor,
              boxWidth: 10
            }
          }
          else {
            obj = {
              label: `${i+1}/${this.secDatasetYear}: ${format(dataset.data[i])}`,
              backgroundColor: secDatasetColor,
              boxWidth: 10
            }
          }
        }
        if (dataset.data[i] !== 0 && obj !== null) {
          chart.data.datasets.push(obj);
          if(yearControl === 0){
            offsetSecondComparativeGroup++;
          }
        }
      }
      yearControl++;
    });

    chart.data.datasets = this.changeChartLegendPosition(chart.data.datasets, offsetSecondComparativeGroup, hiddenInfo);

    chart.update();

    setTimeout(()=> {
      this.exportChartImage.save(name);
    },100);

    setTimeout(() => {
      this.undoChanges(chart);
    }, 300)

  }

  saveCurrentDataChart(chart: any){
    this.legendPosition = chart.options.legend.position;
    this.barPaddingTop = chart.options.layout.padding.top;
    this.animation = chart.options.legend.animation;
    this.datasets = [...chart.data.datasets];
    this.firstDatasetYear = chart.data.datasets[0].label;
    this.secDatasetYear = chart.data.datasets[1].label;
  }

  undoChanges(chart: any){
    chart.options.animation.onComplete = () => {};
    chart.options.legend.position = this.legendPosition;
    chart.options.layout.padding.top = this.barPaddingTop;
    chart.options.legend.animation = this.animation;
    chart.data.datasets = this.datasets;
    chart.data.datasets[0].label = this.firstDatasetYear;
    chart.data.datasets[1].label = this.secDatasetYear;
    chart.update();
  }

  //com todos os labels prontos, apenas trocamos eles de posicao, pra nao ficar 1/2024, 1/2025, 2/2024, 3/2024...
  //caso um ou outro nao apareça, (o user clicou pra riscar o primeiro ou o segundo, também ocultamos as legendas aqui)
  changeChartLegendPosition(datasets : any[], offset: number, hiddenInfo: any[]) : any[] {
    const legendNumber : number = datasets.length;
    const saveData : any = datasets[1];
    datasets.splice(1,1);
    const subArray : any [] = datasets.splice(offset + 1, legendNumber-offset-1);
    //todos os meses do segundo ano
    if (hiddenInfo[0] === false){
      datasets = [];
    }
    if (hiddenInfo[1] === true){
      let secondDataset: any [] = [];
      secondDataset = secondDataset.concat(saveData);
      secondDataset = secondDataset.concat(subArray);
      datasets = datasets.concat(secondDataset);
    }
    return datasets;
  }
}
